(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-assets"] && !Shopify.designMode) return;
  try {
    /* Product popup for cards rendered with enable_popup (one global handler, each popup is set up on first open) */
  (function () {
    if (window.__cardPopupReady) return;
    window.__cardPopupReady = true;

    var openDialog = null;
    var unsubscribe = null;

    function ensureSubscription() {
      if (unsubscribe) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          if (openDialog) closeModal(openDialog);
        });
      }
    }

    function closeModal(dlg) {
      if (!dlg.open) return;
      dlg.classList.remove('is-open');
      clearTimeout(dlg._closeTimer);
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      dlg._closeTimer = setTimeout(
        function () {
          if (dlg.open && !dlg.classList.contains('is-open')) dlg.close();
        },
        reduced ? 0 : 340
      );
    }

    function openModal(dlg, trigger) {
      ensureSubscription();
      setup(dlg);
      dlg._trigger = trigger || null;
      openDialog = dlg;
      clearTimeout(dlg._closeTimer);

      var gallery = dlg.querySelector('[data-cp-gallery]');
      if (gallery) gallery.scrollTo({ left: 0, behavior: 'auto' });
      var scroller = dlg.querySelector('.cp-pop__scroll');
      if (scroller) scroller.scrollTop = 0;

      if (!dlg.open) dlg.showModal();
      document.body.classList.add('overflow-hidden');

      // two frames so the closed state is painted first and the open transition runs
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (dlg.open) dlg.classList.add('is-open');
        });
      });
    }

    function setup(dlg) {
      if (dlg._ready) return;
      dlg._ready = true;

      var closeBtn = dlg.querySelector('[data-cp-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { closeModal(dlg); });

      // click on the dimmed backdrop closes the popup
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) closeModal(dlg);
      });

      dlg.addEventListener('close', function () {
        clearTimeout(dlg._closeTimer);
        dlg.classList.remove('is-open');
        if (openDialog === dlg) openDialog = null;
        if (!document.querySelector('dialog.cp-modal[open]')) document.body.classList.remove('overflow-hidden');
        if (dlg._trigger && dlg._trigger.focus) dlg._trigger.focus();
      });

      // Escape: animate out instead of closing instantly
      dlg.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeModal(dlg);
      });

      initProduct(dlg);
    }

    function initProduct(dlg) {
      var dataEl = dlg.querySelector('[data-cp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = dlg.querySelector('form');
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var addBtn = dlg.querySelector('[type="submit"]');
      var addText = dlg.querySelector('[data-cp-add-text]');
      var buyBtn = dlg.querySelector('[data-cp-buy]');
      var groups = Array.prototype.slice.call(dlg.querySelectorAll('[data-cp-option]'));
      var priceEl = dlg.querySelector('[data-cp-price]');
      var compareEl = dlg.querySelector('[data-cp-compare]');
      var offEl = dlg.querySelector('[data-cp-off]');
      var gallery = dlg.querySelector('[data-cp-gallery]');
      var gdots = Array.prototype.slice.call(dlg.querySelectorAll('[data-cp-gdot]'));

      var t = { add: dlg.dataset.tAdd, sold: dlg.dataset.tSold, unavailable: dlg.dataset.tUnavailable };

      function setDisabled(disabled) {
        [addBtn, buyBtn].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = disabled;
          btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        });
      }

      function findVariant(values) {
        return variants.find(function (v) {
          return v.options.every(function (o, k) { return o === values[k]; });
        });
      }

      function scrollToMedia(mediaId) {
        if (!gallery || !mediaId) return;
        var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
        if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      function update(scrollMedia) {
        var selected = groups.map(function (g) {
          var checked = g.querySelector('input:checked');
          return checked ? checked.value : null;
        });

        // labels + unavailable (sold out / missing) values for the other selections
        groups.forEach(function (g, i) {
          var label = g.querySelector('[data-cp-selected]');
          if (label) label.textContent = selected[i];
          g.querySelectorAll('input').forEach(function (input) {
            var test = selected.slice();
            test[i] = input.value;
            var match = findVariant(test);
            input.closest('label').classList.toggle('is-unavailable', !(match && match.available));
          });
        });

        var variant = groups.length ? findVariant(selected) : variants[0];

        if (!variant) {
          setDisabled(true);
          if (addText) addText.textContent = t.unavailable;
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.innerHTML = variant.price;
        if (compareEl) {
          compareEl.hidden = !variant.compare;
          if (variant.compare) compareEl.innerHTML = 'MRP ' + variant.compare;
        }
        if (offEl) {
          offEl.hidden = !(variant.off > 0);
          if (variant.off > 0) offEl.textContent = variant.off + '% OFF';
        }

        setDisabled(!variant.available);
        if (addText) addText.textContent = variant.available ? t.add : t.sold;
        if (scrollMedia) scrollToMedia(variant.media);
      }

      groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
      update(false);

      // fallback close: when the add-to-cart request finishes without an error, close the popup
      if (addBtn) {
        var errorWrapper = dlg.querySelector('.product-form__error-message-wrapper');
        var wasLoading = false;
        new MutationObserver(function () {
          var loading = addBtn.classList.contains('loading');
          if (loading) {
            wasLoading = true;
          } else if (wasLoading) {
            wasLoading = false;
            setTimeout(function () {
              if (errorWrapper && !errorWrapper.hidden) return;
              if (dlg.open) closeModal(dlg);
            }, 50);
          }
        }).observe(addBtn, { attributes: true, attributeFilter: ['class'] });
      }

      // gallery dots
      if (gallery && gdots.length) {
        gallery.addEventListener(
          'scroll',
          function () {
            var idx = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
            gdots.forEach(function (d, n) { d.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
          },
          { passive: true }
        );
        gdots.forEach(function (d, n) {
          d.addEventListener('click', function () {
            gallery.scrollTo({ left: n * gallery.clientWidth, behavior: 'smooth' });
          });
        });
      }

      // buy now: add the selected variant, then go straight to checkout
      if (buyBtn && idInput) {
        buyBtn.addEventListener('click', async function () {
          if (buyBtn.getAttribute('aria-disabled') === 'true') return;
          buyBtn.setAttribute('aria-disabled', 'true');
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          try {
            var res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(idInput.value), quantity: 1 }),
            });
            if (!res.ok) throw new Error('add failed');
            window.location.href = root + 'checkout';
          } catch (err) {
            buyBtn.setAttribute('aria-disabled', 'false');
            var wrapper = dlg.querySelector('.product-form__error-message-wrapper');
            var message = dlg.querySelector('.product-form__error-message');
            if (wrapper && message) {
              message.textContent = t.unavailable;
              wrapper.hidden = false;
            }
          }
        });
      }
    }

    // The card's quick add button opens the popup instead of adding to the cart (capture phase: runs before the form submits)
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('.product-card-wrapper[data-card-popup] .quick-add button');
        if (!btn || btn.disabled) return;
        var wrapper = btn.closest('.product-card-wrapper');
        var dlg = wrapper && wrapper.querySelector('dialog.cp-modal');
        if (!dlg) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openModal(dlg, btn);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    /* Product popup for cards rendered with enable_popup (one global handler, each popup is set up on first open) */
  (function () {
    if (window.__cardPopupReady) return;
    window.__cardPopupReady = true;

    var openDialog = null;
    var unsubscribe = null;

    function ensureSubscription() {
      if (unsubscribe) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          if (openDialog) closeModal(openDialog);
        });
      }
    }

    function closeModal(dlg) {
      if (!dlg.open) return;
      dlg.classList.remove('is-open');
      clearTimeout(dlg._closeTimer);
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      dlg._closeTimer = setTimeout(
        function () {
          if (dlg.open && !dlg.classList.contains('is-open')) dlg.close();
        },
        reduced ? 0 : 340
      );
    }

    function openModal(dlg, trigger) {
      ensureSubscription();
      setup(dlg);
      dlg._trigger = trigger || null;
      openDialog = dlg;
      clearTimeout(dlg._closeTimer);

      var gallery = dlg.querySelector('[data-cp-gallery]');
      if (gallery) gallery.scrollTo({ left: 0, behavior: 'auto' });
      var scroller = dlg.querySelector('.cp-pop__scroll');
      if (scroller) scroller.scrollTop = 0;

      if (!dlg.open) dlg.showModal();
      document.body.classList.add('overflow-hidden');

      // two frames so the closed state is painted first and the open transition runs
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (dlg.open) dlg.classList.add('is-open');
        });
      });
    }

    function setup(dlg) {
      if (dlg._ready) return;
      dlg._ready = true;

      var closeBtn = dlg.querySelector('[data-cp-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { closeModal(dlg); });

      // click on the dimmed backdrop closes the popup
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) closeModal(dlg);
      });

      dlg.addEventListener('close', function () {
        clearTimeout(dlg._closeTimer);
        dlg.classList.remove('is-open');
        if (openDialog === dlg) openDialog = null;
        if (!document.querySelector('dialog.cp-modal[open]')) document.body.classList.remove('overflow-hidden');
        if (dlg._trigger && dlg._trigger.focus) dlg._trigger.focus();
      });

      // Escape: animate out instead of closing instantly
      dlg.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeModal(dlg);
      });

      initProduct(dlg);
    }

    function initProduct(dlg) {
      var dataEl = dlg.querySelector('[data-cp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = dlg.querySelector('form');
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var addBtn = dlg.querySelector('[type="submit"]');
      var addText = dlg.querySelector('[data-cp-add-text]');
      var buyBtn = dlg.querySelector('[data-cp-buy]');
      var groups = Array.prototype.slice.call(dlg.querySelectorAll('[data-cp-option]'));
      var priceEl = dlg.querySelector('[data-cp-price]');
      var compareEl = dlg.querySelector('[data-cp-compare]');
      var offEl = dlg.querySelector('[data-cp-off]');
      var gallery = dlg.querySelector('[data-cp-gallery]');
      var gdots = Array.prototype.slice.call(dlg.querySelectorAll('[data-cp-gdot]'));

      var t = { add: dlg.dataset.tAdd, sold: dlg.dataset.tSold, unavailable: dlg.dataset.tUnavailable };

      function setDisabled(disabled) {
        [addBtn, buyBtn].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = disabled;
          btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        });
      }

      function findVariant(values) {
        return variants.find(function (v) {
          return v.options.every(function (o, k) { return o === values[k]; });
        });
      }

      function scrollToMedia(mediaId) {
        if (!gallery || !mediaId) return;
        var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
        if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      function update(scrollMedia) {
        var selected = groups.map(function (g) {
          var checked = g.querySelector('input:checked');
          return checked ? checked.value : null;
        });

        // labels + unavailable (sold out / missing) values for the other selections
        groups.forEach(function (g, i) {
          var label = g.querySelector('[data-cp-selected]');
          if (label) label.textContent = selected[i];
          g.querySelectorAll('input').forEach(function (input) {
            var test = selected.slice();
            test[i] = input.value;
            var match = findVariant(test);
            input.closest('label').classList.toggle('is-unavailable', !(match && match.available));
          });
        });

        var variant = groups.length ? findVariant(selected) : variants[0];

        if (!variant) {
          setDisabled(true);
          if (addText) addText.textContent = t.unavailable;
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.innerHTML = variant.price;
        if (compareEl) {
          compareEl.hidden = !variant.compare;
          if (variant.compare) compareEl.innerHTML = 'MRP ' + variant.compare;
        }
        if (offEl) {
          offEl.hidden = !(variant.off > 0);
          if (variant.off > 0) offEl.textContent = variant.off + '% OFF';
        }

        setDisabled(!variant.available);
        if (addText) addText.textContent = variant.available ? t.add : t.sold;
        if (scrollMedia) scrollToMedia(variant.media);
      }

      groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
      update(false);

      // fallback close: when the add-to-cart request finishes without an error, close the popup
      if (addBtn) {
        var errorWrapper = dlg.querySelector('.product-form__error-message-wrapper');
        var wasLoading = false;
        new MutationObserver(function () {
          var loading = addBtn.classList.contains('loading');
          if (loading) {
            wasLoading = true;
          } else if (wasLoading) {
            wasLoading = false;
            setTimeout(function () {
              if (errorWrapper && !errorWrapper.hidden) return;
              if (dlg.open) closeModal(dlg);
            }, 50);
          }
        }).observe(addBtn, { attributes: true, attributeFilter: ['class'] });
      }

      // gallery dots
      if (gallery && gdots.length) {
        gallery.addEventListener(
          'scroll',
          function () {
            var idx = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
            gdots.forEach(function (d, n) { d.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
          },
          { passive: true }
        );
        gdots.forEach(function (d, n) {
          d.addEventListener('click', function () {
            gallery.scrollTo({ left: n * gallery.clientWidth, behavior: 'smooth' });
          });
        });
      }

      // buy now: add the selected variant, then go straight to checkout
      if (buyBtn && idInput) {
        buyBtn.addEventListener('click', async function () {
          if (buyBtn.getAttribute('aria-disabled') === 'true') return;
          buyBtn.setAttribute('aria-disabled', 'true');
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          try {
            var res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: Number(idInput.value), quantity: 1 }),
            });
            if (!res.ok) throw new Error('add failed');
            window.location.href = root + 'checkout';
          } catch (err) {
            buyBtn.setAttribute('aria-disabled', 'false');
            var wrapper = dlg.querySelector('.product-form__error-message-wrapper');
            var message = dlg.querySelector('.product-form__error-message');
            if (wrapper && message) {
              message.textContent = t.unavailable;
              wrapper.hidden = false;
            }
          }
        });
      }
    }

    // The card's quick add button opens the popup instead of adding to the cart (capture phase: runs before the form submits)
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('.product-card-wrapper[data-card-popup] .quick-add button');
        if (!btn || btn.disabled) return;
        var wrapper = btn.closest('.product-card-wrapper');
        var dlg = wrapper && wrapper.querySelector('dialog.cp-modal');
        if (!dlg) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        openModal(dlg, btn);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
